// src/Utils/googleSession.ts
import { Capacitor } from '@capacitor/core';

export async function clearGoogleSession() {
  if (Capacitor.getPlatform() === 'web') {
    const { googleLogout } = await import('@react-oauth/google');
    googleLogout();
    (window as any).google?.accounts?.id?.disableAutoSelect?.();
  } else {
    // For native, clear browser cookies (optional, as tokens are handled server-side)
    // No specific action needed unless you store tokens locally
  }
}